module.exports = {
    language: {
        name: 'en'
    },
    managerPage:{
        txt1:'Personal data',
		txt2:'Change password',
		txt3:'Secure Exit',
		txt4:'Workbench',
		txt5:'My Desktop',
		txt6:'Terminal',
		txt7:'System Setting',
		txt8:'Confirm',
		txt9:'Cancel',
		txt10:'Exit successful!',
		txt11:'Are you sure you want to exit?',
		txt12:'Secure Exit',
    },
    login:{
    	txt1:'Enter one user name',
		txt2:'Please enter the password',
		txt3:'Login'
    },
    modal:{
    	txt1:'Assign Users',
		txt2:'S/N',
		txt3:'User name',
		txt4:'Real name',
		txt5:'Mobile phone number',
		txt6:'Unit Name',
		txt7:'Role',
		txt8:'Please select at least one user'
    },
    uDialog:{
    	txt1:'Confirm',
		txt2:'Cancel'
    },
    uploadDialog:{
    	txt1:'Uploading'
    },
    applicationManagement:{
    	txt1:'Current location:',
		txt2:'Application Management',
		txt3:'Apply All',
		txt4:'Please enter an application name',
		txt5:'Search',
		txt6:'S/N',
		txt7:'Name',
		txt8:'Version',
		txt9:'Explain',
		txt10:'Type',
		txt11:'State',
		txt12:'Not installed',
		txt13:'Already installed',
		txt14:'Instaling',
		txt15:'Operation',
		txt16:'Uninstall',
		txt17:'Install',
		txt18:'Are you sure you want to Delete this user',
		txt19:'At the same time. all data under that user will be Deleted.',
		txt20:'Delete',
		txt21:'Cancel',
		txt22:'Confirm',
		txt23:'Cancelled deletion',
		txt24:'Successfully Deleted',
		txt25:'Operation successful',
		txt26:'Please select'
    },
    contactPage:{
    	txt1:'Current location:',
		txt2:'Copyright management',
		txt3:'Contact us',
		txt4:'Copyright Information',
		txt5:'Please leave your valuable feedback and ideas',
		txt6:'Cancel',
		txt7:'Submit',
		txt8:'Current version:',
		txt9:'Current status:',
		txt10:'Current system status',
		txt11:'Activated',
		txt12:'Not active',
		txt13:'Export Configuration',
		txt14:'Renewal',
		txt15:'Activation',
		txt16:'Check for updates:',
		txt17:'System detection new version',
		txt18:'Latest version',
		txt19:'Upgrade now',
		txt20:'Upgrading',
		txt21:'Backup and Recovery:',
		txt22:'Export Data',
		txt23:'Import Data',
		txt24:'Bottom copyright:',
		txt25:'Please enter content',
		txt26:'Login page logo:',
		txt27:'Submit',
		txt28:'Operation successful!',
		txt29:'Currently limited to selecting 1 file, 1 file has been selected this time, and a total of 1 fle has been selected. Please Delete and upload',
		txt30:'The uploaded file can only be in JPG,JPEG, or PNG format!',
		txt31:'Download successful!',
		txt32:'Export successful!'
    },
    diskMain:{
    	txt1:'S/N',
		txt2:'File name',
		txt3:'Please enter content',
		txt4:'File size',
		txt5:'Upload time',
		txt6:'Select All',
		txt7:'There is currentlv no data available',
		txt8:'Are you sure to Delete the selected file',
		txt9:'Files cannot be retrieved after deletion',
		txt10:'Delete',
		txt11:'Cancel',
		txt12:'Confirm',
		txt13:'Cancelled deletion',
		txt14:'Successfully Deleted!',
		txt15:'New Folder',
		txt16:'Must start with a letter and combine letters, numbers, and underscores ( _) at will'
    },
    project:{
    	txt1:'Select Project',
		txt2:'Project Name',
		txt3:'Project Description',
		txt4:'Creation time',
		txt5:'Please select a project'
    },
    share:{
    	txt1:'Share',
		txt2:'Platform sharing',
		txt3:'Please enter the user you want to search for',
		txt4:'user name',
		txt5:'Link sharing',
		txt6:'Sharing format',
		txt7:'Private Link',
		txt8:'Extract code',
		txt9:'Only those who have extracted the code can view it for greater privacy and security',
		txt10:'Validity period',
		txt11:'Private Link',
		txt12:'Please enter content',
		txt13:'Extract code',
		txt14:'Please enter content',
		txt15:'Successfully created a private link. Please copy the link and extract the code, and send the link to your friend',
		txt16:'Confirm',
		txt17:'Copy Link and Extract Code',
		txt18:'Create link',
		txt19:'Close',
		txt20:'7 days',
		txt21:'15 days',
		txt22:'30 davs',
		txt23:'Permanent',
		txt24:'Successfully copied!',
		txt25:'Please select an expiration time',
		txt26:'Sharing successful!',
		txt27:'Please select the users to share'
    },
    myDoc:{
    	txt1:'Upload files',
		txt2:'Upload folder',
		txt3:'New Folder',
		txt4:'Delete',
		txt5:'Rename',
		txt6:'Download',
		txt7:'Share',
		txt8:'Please select',
		txt9:'Please enter the file you want to search for',
		txt10:'Search',
		txt11:'Current location:',
		txt12:'My data',
		txt13:'My Files',
		txt14:'Alternative options',
		txt15:'List arrangement',
		txt16:'Grid arrangement',
		txt17:'Please select at least one file or folder',
		txt18:'Are vou sure to Delete the selected file',
		txt19:'Files cannot be retrieved after deletion',
		txt20:'Confirm',
		txt21:'Cancel',
		txt22:'Please select a file or folder',
		txt23:'Please enter a name',
		txt24:'Renamed successfully!',
		txt25:'Successfully Deleted!',
		txt26:'Successfully saved!',
		txt27:'Folder',
		txt28:'New Folder',
		txt29:'Please enter a folder name',
		txt30:'Must start with a letter and combine letters, numbers, and underscores ( ) at will',
		txt31:'Successfully created folder!',
		txt32:'Download successful!',
		txt33:'Download permission has been turned off',
		txt34:'File Upload',
        txt35:'We have detected that the uploaded file already exists. Please Confirm before continuing.',
        txt36:'Ignore',
        txt37:'Overwrite',
        txt38:'Keep both',
        txt39:'Data synchronization client download',
        txt40:'Client supports Win. Mac version',
        txt41:'Only supports selecting one file for download',
		txt42:'Open client'
    },
    myShare:{
    	txt1:'Current location:',
		txt2:'My data',
		txt3:'My Sharing',
		txt4:'Cancel sharing',
		txt5:'Sharing type',
		txt6:'Platform sharing',
		txt7:'Link sharing',
		txt8:'Share time',
		txt9:'Other documents',
		txt0:'Please select at least one file or folder',
		txt11:'This operation will Cancel the sharing of this file. Do you want to continue?',
		txt12:'Cancel sharing',
		txt13:'Confirm',
		txt14:'Cancel',
		txt15:'Cancel sharing successfully!',
		txt16:'This operation will permanently Delete the on-site witness record. Do you want to continue?',
    	txt17:'File name',
		txt18:'Receive',
		txt19:'Share',
    },
    patfromShare:{
    	txt1:'Current location:',
		txt2:'My data',
		txt3:'My Files',
		txt4:'Platform sharing',
		txt5:'Link sharing',
		txt6:'Cancel',
		txt7:'Confirm',
		txt8:'Copy Link and Extract Code',
		txt9:'Create link',
		txt10:'Please enter the user you want to search for',
		txt11:'User name',
		txt12:'Sharing format',
		txt13:'Private Link',
		txt14:'Extract code',
		txt15:'Only those who have extracted the code can view it for greater privacy and security',
		txt16:'Validity period',
		txt17:'Please select',
		txt18:'Private Link',
		txt19:'Please enter content',
		txt20:'Extract code',
		txt21:'Successfully created a private link. Please copy the link and extract the code, and send the link to your friend',
		txt22:'7 days',
		txt23:'15 days',
		txt24:'30 davs',
		txt25:'Permanent',
		txt26:'Please select the users to share',
		txt27:'Successfully copied!',
		txt28:'Please select an expiration time',
		txt29:'Sharing successful!'
    },
    receiveShare:{
    	txt1:'Current location:',
		txt2:'My data',
		txt3:'Receive sharing',
		txt4:'Save to My File',
		txt5:'Delete',
		txt6:'File name',
		txt7:'Sharing type',
		txt8:'Platform sharing',
		txt9:'Link sharing',
		txt10:'Share time',
		txt11:'Received successfully',
		txt12:'Operation successful!',
		txt13:'This operation will Cancel the sharing of this file. Do you want to continue?',
		txt14:'Confirm',
		txt15:'Cancel',
		txt16:'Cancel sharing successfully!'
    },
    MyProjectManagementEdit:{
    	txt1:'Edit Proiect',
		txt2:'Create Project',
		txt3:'Please enter the project name (a combination of letters, numbers, and underscores)',
		txt4:'Confirm',
		txt5:'Cancel',
		txt6:'Please enter a proiect name',
		txt7:'Must start with a letter and combine letters, numbers, and underscores ( ) at will',
		txt8:'Cannot be root'
	},
	MyProjectManagementList:{
		txt1:'Administrator:',
		txt2:'Participants:',
		txt3:'The date you personally created this project:'
	},
    aduit:{
    	txt1:'Current location:',
		txt2:'Shared Space',
		txt3:'Approval Management',
		txt4:'Please select',
		txt5:'Please enter an application name',
		txt6:'Search',
		txt7:'Applicant',
		txt8:'Application documents',
		txt9:'Matter',
		txt10:'Apply for download',
		txt11:'Application time',
		txt12:'State',
		txt13:'Waiting for review',
		txt14:'Agreed',
		txt15:'Rejected',
		txt16:'Operation',
		txt17:'Agree',
		txt18:'Refuse',
		txt19:'Download',
		txt20:'Whole',
		txt21:'I approved it',
		txt22:'I applied for it',
		txt23:'Operation successful!',
		txt24:'Are you sure you want to Delete this user',
		txt25:'At the same time, all data under that user will be Deleted.',
		txt26:'Delete',
		txt27:'Cancel',
		txt28:'Confirm',
		txt29:'Cancelled deletion',
		txt30:'Successfully Deleted!',
		txt31:'Are you sure you want to freeze this user',
		txt32:'After freezing, you will not be able to log in to the platform.',
		txt33:'Freeze',
		txt34:'Unfreeze',
		txt35:'Frozen successfully!'
    },
    authoritySettings:{
    	txt1:'Current location:',
		txt2:'Shared Space',
		txt3:'Managed Projects',
		txt4:'Permission settings',
		txt5:'Return to previous page',
		txt6:'Preserve',
		txt7:'Project File Permission Settings',
		txt8:'Project administrator',
		txt9:'Read',
		txt10:'Write',
		txt11:'Browse',
		txt12:'Project members',
		txt13:'Members outside the project',
		txt14:'Operation successful'
    },
    management:{
    	txt1:'Current location:',
		txt2:'Shared Space',
		txt3:'Managed Projects',
		txt4:'Projects Participated in',
		txt5:'Please enter a project name',
		txt6:'Search',
		txt7:'Create Project',
		txt8:'Administrator:',
		txt9:'Members:',
		txt10:'Participants:',
		txt11:'This project',
		txt12:'Created on:',
		txt13:'There are currently no projects available'
    },
    managementDetail:{
		txt1: 'Current position:',
		txt2: 'Share Space',
		txt3: 'Managed projects',
		txt4: 'Participating projects',
		txt5: 'Upload',
		txt6: 'File',
		txt7: 'Folder',
		txt8: 'Import',
		txt9: 'Apply for download',
		txt10: 'Download',
		txt11: 'Project members',
		txt12: 'Project settings',
		txt13: 'Return to previous page',
		txt14: 'S/N',
		txt15: 'File name',
		txt16: 'Please enter content',
		txt17: 'Upload time',
		txt18: 'Operation',
		txt19: 'Rename',
		txt20: 'Apply for download',
		txt21: 'Download',
		txt22: 'Delete',
		txt23: 'Upload my data',
		txt24: 'Current position:',
		txt25: 'My Files',
		txt26: 'Serial number',
		txt27: 'File name',
		txt28: 'Please enter the content',
		txt29: 'Upload time',
		txt30: 'OK',
		txt31: 'Cancel',
		txt32: 'Apply for download',
		txt33: 'Please note that non project administrators need to apply to the administrator to download materials. You can "Confirm" and:',
		txt34: '1. Notify the administrator on your own, and the administrator will Confirm your application through My Project ->Approval Management ;',
		txt35: '2. Approval results can be viewed in My Project ->Approval Management ',
		txt36: 'Application successful!',
		txt37: 'Please enter a name',
		txt38: 'OK',
		txt39: 'Cancel',
		txt40: 'Renaming successful!',
		txt41: 'Please select at least one file or folder',
		txt42: 'Are you sure to Delete the selected file?',
		txt43: 'Files cannot be retrieved after deletion',
		txt44: 'OK',
		txt45: 'Cancel',
		txt46: 'Successfully Deleted',
		txt47: 'Download successful!',
		txt48: 'Download permission has been closed',
		txt49: 'Successfully added label!',
		txt50: 'Successfully Deleted label!',
		txt51: 'Successfully Deleted user!',
		txt52: 'Please select at least one file or folder',
		txt53: 'Successfully uploaded my data!'
	},
    projectMembers:{
    	txt1:'Current location:',
		txt2:'Shared Space',
		txt3:'Managed Projects',
		txt4:'Joined members',
		txt5:'Add Members',
		txt6:'Search',
		txt7:'Search',
		txt8:'Return to previous page',
		txt9:'Creator',
		txt10:'Manager',
		txt11:'Member',
		txt12:'Set as administrator',
		txt13:'Remove',
		txt14:'Add'
    },
    projectSettings:{
    	txt1:'Current location:',
		txt2:'Shared Space',
		txt3:'Managed Projects',
		txt4:'Project Settings',
		txt5:'Return to previous page',
		txt6:'Project Settings',
		txt7:'Save',
		txt8:'Delete item',
		txt9:'Entry name',
		txt10:'Please enter a project name',
		txt11:'Project File Permission Settings',
		txt12:'Project administrator',
		txt13:'Read',
		txt14:'Write',
		txt15:'Browse',
		txt16:'Project members',
		txt17:'Members outside the project',
		txt18:'Project Description',
		txt19:'Are you sure you want to completely Delete this project?',
		txt20:'The Deleted item cannot be retrieved. Please think twice before deleting it.',
		txt21:'Delete',
		txt22:'Confirm',
		txt23:'Cancel',
		txt24:'Successfully Deleted!',
		txt25:'Operation successful',
		txt26:'Please enter a project description'
    },
    Chart:{
    	txt1:'CPU usage rate',
		txt2:'MEMORY usage rate',
		txt3:'Usage rate (%)'
    },
    PlatformMonitoringList:{
    	txt1:'Current location:',
		txt2:'Platform monitoring',
		txt3:'Cluster monitoring',
		txt4:'Server:'
    },
    userAssignment:{
    	txt1:'share',
		txt2:'Platform sharing',
		txt3:'Please enter the user you want to search for',
		txt4:'User name',
		txt5:'Link sharing',
		txt6:'Sharing format',
		txt7:'Private Link',
		txt8:'Extract code',
		txt9:'Only those who have extracted the code can view it for greater privacy and security',
		txt10:'Validity period',
		txt11:'Please select',
		txt12:'Private Link',
		txt13:'Extract code',
		txt14:'Please enter content',
		txt15:'Successfully created a private link. Please copy the link and extract the code, and send the link to yourfriend',
		txt16:'Confirm',
		txt17:'Cancel',
		txt18:'Copy Link and Extract Code',
		txt19:'Close',
		txt20:'Please select the users to share',
		txt21:'Sharing successful!'
    },
    addQueue:{
    	txt1:'Add Queue',
		txt2:'Cancel',
		txt3:'Confirm',
		txt4:'Queue name:',
		txt5:'Please enter a queue name',
		txt6:'Project:',
		txt7:'Please select',
		txt8:'User:',
		txt9:'Please select',
		txt10:'Current location:',
		txt11:'Resource management',
		txt12:'Queue management',
		txt13:'Add Queue',
		txt14:'Select All',
		txt15:'There is currently no data available',
		txt16:'Internal network address:',
		txt17:'Current status:',
		txt18:'On line',
		txt19:'Off-line',
		txt20:'CPU cores',
		txt21:'Please enter a queue name',
		txt22:'Must start with a letter and combine letters, numbers, and underscores ( ) at will'
    },
    calculateDot:{
    	txt1:'Currentlocation.',
		txt2:'Resource management',
		txt3:'Computing nodes',
		txt4:'Add Node',
		txt5:'Internalnetwork address:',
		txt6:'Current status:',
		txt7:'On line',
		txt8:'Off-line',
		txt9:'Are you sure to Delete this node?',
		txt10:'Delete this node and the online user desktop on this node will be closed!',
		txt11:'Delete',
		txt12:'Confirm',
		txt13:'Cancel',
		txt14:'Cancelled deletion',
		txt15:'Successfully Deleted!'
    },
    desktopDot:{
    	txt1:'Current location:',
		txt2:'Resource management',
		txt3:'Desktop Node',
		txt4:'Add Node',
		txt5:'Internal network address',
		txt6:'External network address',
		txt7:'Current status:',
		txt8:'Number of online users',
		txt9:'Port',
		txt10:'Describe',
		txt11:'On line',
		txt12:'Off-line',
		txt13:'Are you sure to Delete this node?',
		txt14:'Delete this node, and the online user desktop on this node will be closed!',
		txt15:'Delete',
		txt16:'Confirm',
		txt17:'Cancel',
		txt18:'Cancelled deletion',
		txt19:'Successfully Deleted!'
    },
    editCalculateDot:{
    	txt1:'Current location:',
		txt2:'Resource management',
		txt3:'Computing nodes',
		txt4:'Edit nodes',
		txt5:'Add Node',
		txt6:'Return to previous page',
		txt7:'Edit nodes',
		txt8:'Add Node',
		txt9:'Cancel',
		txt10:'Confirm',
		txt11:'Hostname',
		txt12:'Please enter the Hostname',
		txt13:'Internal network address',
		txt14:'Please enter the intemnal network IP',
		txt15:'Describe',
		txt16:'Please enter a description',
		txt17:'Please enter the Hostname',
		txt18:'Please enter the intranet address',
		txt19:'Please enter a valid and qualified IP address'
    },
    editDesktopDot:{
    	txt1:'Current location:',
		txt2:'Resource management',
		txt3:'Desktop Node',
		txt4:'Edit nodes',
		txt5:'Add Node',
		txt6:'Return to previous page',
		txt7:'Cancel',
		txt8:'Confirm',
		txt9:'Node Name',
		txt10:'Please enter a node name',
		txt11:'Internalnetwork address',
		txt12:'Please enter the intranet address',
		txt13:'External network address',
		txt14:'Please enter the internet address',
		txt15:'Port',
		txt16:'Please enter the port',
		txt17:'URL Link',
		txt18:'Please enter the URL link',
		txt19:'describe',
		txt20:'Please enter a description',
		txt21:'Please enter a node name',
		txt22:'Must start with a letter and combine letters, numbers, and underscores ( ) at will',
		txt23:'Please enter the intranet address',
		txt24:'Please enter a valid and qualified IP address',
		txt25:'Please enter the intemet address',
		txt26:'Please enter a valid and qualified lP address or the correct domain name address',
		txt27:'Please enter the port',
		txt28:'The port number is only a number, and the range of values is [0-65535]'
    },
    editQueue:{
    	txt1:'Current location:',
		txt2:'Resource management',
		txt3:'Queue management',
		txt4:'Edit Queue',
		txt5:'Return to previous page',
		txt6:'Cancel',
		txt7:'Confirm',
		txt8:'Queue Name',
		txt9:'Please enter a queue name',
		txt10:'Assign Host',
		txt11:'Please enter the Hostname',
		txt12:'CPU cores',
		txt13:'Please select a host',
		txt14:'Select Project',
		txt15:'Select Users',
		txt16:'Please enter the user name',
		txt17:'Please select a user',
		txt18:'Please enter a node name',
		txt19:'Must start with a letter and combine letters, numbers, and underscores (_) at will',
		txt20:'Please enter the intranet address',
		txt21:'Please enter a valid and qualified IP address',
		txt22:'Please enter the intemet address',
		txt23:'Please enter a valid and qualified IP address or the correct domain name address',
		txt24:'Please enter the port',
		txt25:'The port number is only a number, and the range of values is [0-65535]',
        txt26:'Please select'
    },
    editTask:{
    	txt1:'Current location:',
		txt2:'Resource management',
		txt3:'Job management',
		txt4:'Assignment submission',
		txt5:'Return to previous page',
		txt6:'Cancel',
		txt7:'Working',
		txt8:'Job Name',
		txt9:'Please enter',
		txt10:'Select Queue',
		txt11:'Please select',
		txt12:'Edit Script',
		txt13:'Upload script',
		txt14:'Please enter the assianment name',
		txt15:'Must start with a letter and combine letters, numbers and underscores ( ) at will',
		txt16:'Please enter the script content',
		txt17:'Run successfully!',
		txt18:'Please Delete and upload. The current limit for selecting files is:',
		txt19:'Upload successful!',
		txt20:'File name',
		txt21:'Successfully saved!'
    },
    onlineUser:{
    	txt1:'Current location:',
		txt2:'Resource management',
		txt3:'Online users',
		txt4:'S/N',
		txt5:'User name',
		txt6:'Name',
		txt7:'Desktop Node Name',
		txt8:'Intranet',
		txt9:'External network',
		txt10:'Operation',
		txt11:'Close Desktop',
		txt12:'Are you sure you want to close this desktop',
		txt13:'Close',
		txt14:'Confirm',
		txt15:'Cancel',
		txt16:'Cancelled Close'
    },
    queueManangement:{
    	txt1:'Current location:',
		txt2:'Resource management',
		txt3:'Queue management',
		txt4:'Add Queue',
		txt5:'Main engine',
		txt6:'Project',
		txt7:'User',
		txt8:'Host:',
		txt9:'Add Queue',
		txt10:'Are you sure to Delete this queue?',
		txt11:'Delete this queue and the data on it will be cleared!',
		txt12:'Confirm',
		txt13:'Cancel',
		txt14:'Cancelled deletion',
		txt15:'Successfully Deleted!'
    },
    taskManangement:{
    	txt1:'Current location:',
		txt2:'Resource management',
		txt3:'Job management',
		txt4:'Enter one user name',
		txt5:'Query',
		txt6:'Please enter a queue name',
		txt7:'Assignment submission',
		txt8:'S/N',
		txt9:'Job ID',
		txt10:'Queue Name',
		txt11:'Script Name',
		txt12:'User name',
		txt13:'Duration',
		txt14:'State',
		txt15:'Operation',
		txt16:'Termination',
		txt17:'Terminated successfully!',
		txt18:'Are you sure to terminate this assignment',
		txt19:'Confirm',
		txt20:'Cancel',
		txt21:'Cancelled termination'
    },
    userAssignment:{
    	txt1:'Current location:',
		txt2:'Resource management',
		txt3:'Desktop Node',
		txt4:'User allocation',
		txt5:'Cancel',
		txt6:'Confirm',
		txt7:'Node Name:',
		txt8:'Please enter the user you want to search for',
		txt9:'Search',
		txt10:'All Users List',
		txt11:'Selected Users List',
		txt12:'User name'
    },
    tag:{
    	txt1:'System settings'
    },
    authManagement:{
    	txt1:'Current location:',
		txt2:'System settings',
		txt3:'Permission management',
		txt4:'S/N',
		txt5:'Role Name',
		txt6:'Role encoding',
		txt7:'Menu permission allocation',
		txt8:'Save',
		txt9:'Select Al',
		txt10:'Successfully saved!'
    },
    editMenu:{
    	txt10:'Current location:',
		txt11:'System settings',
		txt12:'Menu management',
		txt13:'Edit Menu',
		txt14:'add menu',
		txt15:'Return to previous page',
		txt16:'Cancel',
		txt17:'Confirm',
		txt18:'Menu Name',
		txt19:'Please enter a menu name',
		txt20:'Please enter the menu URL',
		txt21:'Menu URL',
		txt22:'Parent Menu',
		txt23:'Menu Type',
		txt24:'Please select a menu type',
		txt25:'Menu icon',
		txt26:'Icon requirements:',
		txt27:'lmage length and width 200px * 200px, image file size not exceeding 200KB, supporting png, jpg, and jpeg',
		txt28:'Delete Picture',
		txt29:'Please enter a menu name',
		txt30:'Please enter the menu URL',
		txt31:'Please select a menu type',
		txt32:'Request forwarding (this system)',
		txt33:'Redirect (such as redirecting to a third-party website)',
		txt34:'Internaljump(specific request) to open a new page',
		txt35:'Top level menu',
		txt36:'Successfully saved!',
		txt37:'Currently limited to selecting 1 fle, 1 file has been selected this time, and a total of 1 file has been selected. Please Delete and upload'
    },
    logManagement:{
    	txt1:'Current location:',
		txt2:'System settings',
		txt3:'Log management',
		txt4:'S/N',
		txt5:'Log Type',
		txt6:'Module',
		txt7:'Content',
		txt8:'User ID',
		txt9:'user name',
		txt10:'Record time'
    },
    menuManagement:{
    	txt1:'Current location:',
		txt2:'System settings',
		txt3:'Menu management',
		txt4:'Add menu',
		txt5:'Menu Name',
		txt6:'Menu URL',
		txt7:'Menu Type',
		txt8:'Menu icon',
		txt9:'Operation',
		txt10:'Edit',
		txt11:'Delete',
		txt12:'Request forwarding (this system)',
		txt13:'Redirect (such as redirecting to a third-party website)',
		txt14:'Internal jump (specific request) to open a new page',
		txt15:'Top level menu',
		txt16:'Are vou sure to Delete this menu?',
		txt17:'Delete this menu, it will be cleared in the system!',
		txt18:'Confirm',
		txt19:'Cancel',
		txt20:'Successfully Deleted!'
    },
    roleManagement:{
    	txt1:'Current location:',
		txt2:'System settings',
		txt3:'Role Management',
		txt4:'Add Role',
		txt5:'Delete',
		txt6:'Edit',
		txt7:'S/N',
		txt8:'Role Name',
		txt9:'Role Description',
		txt10:'Operation',
		txt11:'User name',
		txt12:'Real name',
		txt13:'Mobile phone number',
		txt14:'Mailbox',
		txt15:'Add Role',
		txt16:'Role Name',
		txt17:'Role Description',
		txt18:'Please enter a role description',
		txt19:'Please enter a role name',
		txt20:'Are vou sure you want to Delete this role?',
		txt21:'Cancelled deletion',
		txt22:'Successfully Deleted!',
		txt23:'Successfully added!',
		txt24:'Please select a user first',
		txt25:'Are vou sure to Delete this user?',
		txt26:'Delete this user, their information in the role will be cleared!',
		txt27:'Cancel',
		txt28:'Confirm',
		txt29:'Successfully Deleted!'
    },
    systemeManagement:{
    	txt1:'Current location:',
		txt2:'System settings',
		txt3:'preserve',
		txt4:'Platform Global Data Download Permission Settings',
		txt5:'Allow download:',
		txt6:'List of disallowed downloads',
		txt7:'Allow list when downloading is not allowed',
		txt8:'Please enter the user you want to search for',
		txt9:'User name',
		txt10:'Successfully saved!'
    },
    editEmail:{
    	txt1:'Current location:',
		txt2:'User Center',
		txt3:'Bind phone',
		txt4:'Bind email',
		txt5:'Bind new email',
		txt6:'Cancel',
		txt7:'Validate',
		txt8:'Confirm',
		txt9:'Please enter the binding email',
		txt10:'Verification code',
		txt11:'Please enter the verification code',
		txt12:'Has been sent',
		txt13:'Second',
		txt14:'Send verification code',
		txt15:'Retrieve',
		txt16:'New email',
		txt17:'Please enter a new email address',
		txt18:'Email cannot be empty',
		txt19:'Please enter the correct email address',
		txt20:'Please enter the email verification code'
    },
    editPassword:{
    	txt1:'Current location:',
		txt2:'User Center',
		txt3:'Change password',
		txt4:'Cancel',
		txt5:'Confirm',
		txt6:'Original password',
		txt7:'Please enter the original password',
		txt8:'New password',
		txt9:'Please enter a new password',
		txt10:'Confirm Password',
		txt11:'Please Confirm the new password',
		txt12:'Please enter the password',
		txt13:'Confirm password cannot be empty',
		txt14:'The two passwords entered do not match',
		txt15:'Length between 6 and 18 digits'
    },
    editPhone:{
    	txt1:'Current location:',
		txt2:'User Center',
		txt3:'Bind phone',
		txt4:'Bind new phone',
		txt5:'Cancel',
		txt6:'validate',
		txt7:'Confirm',
		txt8:'Bind phone',
		txt9:'Please enter the binding phone number',
		txt10:'Verification code',
		txt11:'Please enter the verification code',
		txt12:'Sent for 1 second',
		txt13:'Send verification code',
		txt14:'Retrieve',
		txt15:'New phone number',
		txt16:'Please enter a new phone number',
		txt17:'Please enter your phone number',
		txt18:'Please enter your phone verification code',
		txt19:'Please enter the correct phone number'
    },
    userCenter:{
    	txt1:'Current location:',
		txt2:'User Center',
		txt3:'Cancel',
		txt4:'User name',
		txt5:'name',
		txt6:'Please enter your name',
		txt7:'Preserve',
		txt8:'Password',
		txt9:'Change password',
		txt10:'Bind your phone for easier login and use',
		txt11:'Replace phone',
		txt12:'Bind phone',
		txt13:'Bind email to make login usage more secure',
		txt14:'Unbind',
		txt15:'Bind email',
		txt16:'Successfully saved!'
    },
    activation:{
    	txt1:'Current location:',
		txt2:'user management',
		txt3:'Activate User',
		txt4:'Cancel',
		txt5:'Confirm',
		txt6:'Validity period',
		txt7:'to',
		txt8:'Start date',
		txt9:'End date',
		txt10:'Please select an expiration date',
		txt11:'Successfully unfrozen user!'
    },
    addUser:{
    	txt1:'Edit User',
		txt2:'Add User',
		txt3:'Cancel',
		txt4:'Confirm',
		txt5:'User name',
		txt6:'Please enter',
		txt7:'Password',
		txt8:'Unit Name',
		txt9:'Realname',
		txt10:'Address',
		txt11:'Expiry date',
		txt12:'Start date',
		txt13:'End date',
		txt14:'Please enter the correct email address',
		txt15:'enter one user name',
		txt16:'Please enter the user password'
    },
    editPassword:{
    	txt1:'Current location:',
		txt2:'user management',
		txt3:'Change password',
		txt4:'Cancel',
		txt5:'Confirm',
		txt6:'New password',
		txt7:'Please enter a new password',
		txt8:'Confirm Password',
		txt9:'Please Confirm the new password',
		txt10:'Please enter the password',
		txt11:'Confirm password cannot be empty',
		txt12:'The two passwords entered do not match',
		txt13:'Length between 6 and 18 digits'
    },
    editRole:{
    	txt1:'Current location:',
		txt2:'user management',
		txt3:'Modify Role',
		txt4:'Cancel',
		txt5:'Confirm',
		txt6:'System Role',
		txt7:'Please select a system role'
    },
    userManagement:{
    	txt1:'Current location:',
		txt2:'user management',
		txt3:'Please enter your phone number/username/real name',
		txt4:'Search',
		txt5:'Import Users',
		txt6:'Export Template',
		txt7:'Add User',
		txt8:'S/N',
		txt9:'User name',
		txt10:'Real name',
		txt11:'Phone number',
		txt12:'Mailbox',
		txt13:'Role',
		txt14:'Expiry date',
		txt15:'Operation',
		txt16:'Change password',
		txt17:'Modify Role',
		txt18:'Delete',
		txt19:'Activation',
		txt20:'Freeze',
		txt21:'Validity period',
		txt22:'Start date',
		txt23:'End date',
		txt24:'Confirm',
		txt25:'Cancel',
		txt26:'Please select an expiration date',
		txt27:'User List',
		txt28:'Currently limited to selecting 1 file, 1 file has been selected this time, and a total of 1 file has been selected. Please Delete and upload',
		txt29:'Upload successful!',
		txt30:'Are vou sure vou want to Delete this user',
		txt31:'At the same time. all data under that user will be Deleted.',
		txt32:'Cancelled deletion',
		txt33:'Are you sure you want to freeze this user',
		txt34:'After freezing, you will not be able to log in to the platform.',
		txt35:'Freeze',
		txt36:'Successfully frozen user!',
		txt37:'Successfully unfrozen user!',
		txt38:'Unfreeze'
    },
    noPermission:{
    	txt1:'No permission temporarily'
    },
    workPlat:{
    	txt1:'My data',
		txt2:'My Files',
		txt3:'My Sharing',
		txt4:'Receive sharing',
		txt5:'Shared Space',
		txt6:'Managed Proiects',
		txt7:'Projects Participated in',
		txt8:'Approval Management',
		txt9:'User management',
		txt10:'Resource management',
		txt11:'Desktop Node',
		txt12:'Computing nodes',
		txt13:'Queue management',
		txt14:'Job management',
		txt15:'Platform monitoring',
		txt16:'Cluster monitoring',
		txt17:'Application Management'
    }
}